<template>
  <div>
    <!--替换链接编辑  -->
    <el-dialog :title="$t('message.replaceLinkEditing')" :close-on-click-modal="false"
      :visible.sync="$parent.setReplaceGoodsDialogVisible" width="1820px" center>
      <div class="addGoods">
        <!-- 添加 -->
        <div class="add">
          <el-button size="mini" type="success" @click="add" v-if="status == 21">{{ $t("message.add") }}</el-button>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 商品链接 -->
            <!-- 店铺信息 -->
            <li v-if="status == 22">{{ $t("message.storeInformation") }}</li>
            <li class="flex2" v-if="status == 21">
              {{ $t("message.ProductLink") }}
            </li>
            <!-- 图片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 调查在库数 -->
            <li v-if="status == 21">
              {{ $t("message.investigateTheNumberOfInStock") }}
            </li>
            <!-- 调查单价 -->
            <li v-if="status == 21">{{ $t("message.surveyUnitPrice") }}</li>
            <!-- 调查运费 -->
            <li v-if="status == 21">{{ $t("message.surveyOfFreight") }}</li>
            <!-- 报价在库数 -->
            <li v-if="status == 22">
              {{ $t("message.quoteInLibraryNumber") }}
            </li>
            <!-- 报价单价 -->
            <li v-if="status == 22">
              {{ $t("message.quotationUnitPrice") }}
            </li>
            <!-- 报价国内运费 -->
            <li v-if="status == 22">
              {{ $t("message.quoteDomesticShipping") }}
            </li>
            <!-- 确认采购价 -->
            <li v-if="status == 21">
              {{ $t("message.confirmPurchasePrice") }}
            </li>
            <!-- 确认国内运费 -->
            <li v-if="status == 21">
              {{ $t("message.confirmDomesticShipping") }}
            </li>
            <!-- 单个商品尺寸.cm -->
            <li v-if="status == 21">{{ $t("message.singleItemSize") }}</li>
            <!-- 单个重量.g -->
            <li v-if="status == 21">{{ $t("message.individualWeight") }}</li>
            <!-- 采购备注 -->
            <li class="flex15">{{ $t("message.purchasingNotes") }}</li>
            <!-- 业务回复 -->
            <li class="flex15" v-if="status == 22">
              {{ $t("message.businessReply") }}
            </li>
            <!-- 操作 -->
            <li v-if="status == 21">{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 店铺信息 -->
            <li v-if="status == 22">
              <div class="template">
                <p>{{ item.shop_name }}</p>
                <p style="color: #15ad3c">{{ item.from_platform }}</p>
                <p>{{ item.shop_id }}</p>
              </div>
            </li>
            <!-- 商品链接 -->
            <li class="flex2" v-if="status == 21">
              <el-input v-model="item.link" size="mini" @blur="goodsParticulars(item.link, index)"
                onfocus="this.select()"></el-input>
            </li>
            <!-- 图片 -->
            <li>
              <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <a href="javascript:;" @click="i = index">
                  <el-image :src="item.pic" style="width: 60px; height: 60px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot">
                    </div>
                  </el-image>
                </a>
              </el-upload>

            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute" @click="editAttribute(item, index)">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 调查在库数 -->
            <li v-if="status == 21">
              <el-input v-model="item.confirm_num" size="mini" onfocus="this.select()" type="number"></el-input>
            </li>
            <!-- 调查单价 -->
            <li v-if="status == 21">
              <el-input v-model="item.confirm_price" size="mini" type="number"></el-input>
            </li>
            <!-- 调查运费 -->
            <li v-if="status == 21">
              <el-input v-model="item.confirm_freight" size="mini" onfocus="this.select()" type="number"></el-input>
            </li>
            <!-- 报价在库数 -->
            <li v-if="status == 22">
              <div class="template">
                <p>{{ $t("message.inStock") }}:{{ item.confirm_num }}</p>
                <el-input v-model="item.offer_num" type="number" size="mini" onfocus="this.select()"></el-input>
              </div>
            </li>
            <!-- 报价单价 -->
            <li v-if="status == 22">
              <div class="template">
                <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                <el-input v-model="item.offer_price" type="number" size="mini" onfocus="this.select()"></el-input>
              </div>
            </li>
            <!-- 报价国内运费 -->
            <li v-if="status == 22">
              <div class="template">
                <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
                <el-input v-model="item.offer_freight" type="number" size="mini" onfocus="this.select()"></el-input>
              </div>
            </li>
            <!-- 确认采购价 -->
            <li v-if="status == 21">
              <el-input v-model="item.confirm_dicker_price" size="mini" onfocus="this.select()" type="number"></el-input>
            </li>
            <!-- 确认国内运费 -->
            <li v-if="status == 21">
              <el-input v-model="item.confirm_dicker_freight" size="mini" onfocus="this.select()"
                type="number"></el-input>
            </li>
            <!-- 单个商品尺寸.cm -->
            <li v-if="status == 21">
              <div class="row">
                <p>
                  <el-input v-model="item.length" size="mini" :placeholder="$t('message.length')" onfocus="this.select()"
                    type="number"></el-input>
                </p>
                <p>
                  <el-input v-model="item.width" size="mini" :placeholder="$t('message.width')" onfocus="this.select()"
                    type="number"></el-input>
                </p>
                <p>
                  <el-input v-model="item.height" size="mini" :placeholder="$t('message.height')" onfocus="this.select()"
                    type="number"></el-input>
                </p>
              </div>
            </li>
            <!-- 单个重量.g -->
            <li v-if="status == 21">
              <el-input v-model="item.weight" size="mini" onfocus="this.select()" type="number"></el-input>
            </li>
            <!-- 采购备注 -->
            <li class="flex15">
              <el-input type="textarea" placeholder="请输入内容" v-model="item.g_remark" show-word-limit
                onfocus="this.select()" v-if="status == 21"></el-input>
              <span v-else>
                {{ item.g_remark }}
              </span>
            </li>
            <!-- 业务回复 -->
            <li class="flex15" v-if="status == 22">
              <el-input type="textarea" placeholder="请输入内容" v-model="item.y_reply" show-word-limit
                onfocus="this.select()"></el-input>
            </li>
            <!-- 操作 -->
            <li v-if="status == 21">
              <!-- 删除 -->
              <el-button size="mini" class="dark" type="primary" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.setReplaceGoodsDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 采购保存 -->
        <el-button type="primary" @click="save" v-if="status == 21">{{
          $t("message.save")
        }}</el-button>
        <!-- 业务保存 -->
        <el-button type="primary" @click="updateReplaceGoods" v-if="status == 22">{{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>
    <attribute v-if="attributeDialogVisible" :detail="itemDetai" />
  </div>
</template>
<script>
import attribute from "./attribute";
export default {
  props: {
    detail: { type: Object },
    status: { type: Number },
  },
  components: { attribute },
  data() {
    return {
      val: "",
      radio: "",
      tableData: [
        {
          link: "",
          goods_id: "",
          mi_id: "",
          goods_title: "",
          price: '0',
          detail: "",
          detail_y: "",
          sku_id: "",
          spec_id: "",
          shop_id: "",
          shop_name: "",
          from_platform: "",
          confirm_num: "",
          confirm_freight: "",
          confirm_price: "",
          confirm_dicker_price: "",
          confirm_dicker_freight: "",
          volume: "",
          weight: "",
          g_remark: "",
          length: "",
          width: "",
          height: "",
          pic: "",
          goodsInventory: {}
        },
      ],

      attributeDialogVisible: false,
      i: 0,
      itemDetai: {},
      goodsInventory: [],
    };
  },
  created() {
    if (this.detail.order_detail_replace != false) {

      this.tableData = this.detail.order_detail_replace;
      this.$forceUpdate();
    }
    console.log(this.detail);
  },
  methods: {
    goodsParticulars(link, i) {
      this.$api.goodsUrlToGoodsId({ goods_url: link }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {
          let data = res.data;
          this.goodsInventory = res.data.goodsInfo.goodsInventory;
          this.i = i;
          this.tableData[i].link = link
          this.tableData[i].goods_id = data.goodsId
          this.tableData[i].mi_id = data.mi_id || data.miId || miId
          this.tableData[i].goods_title = data.goods_title
          this.tableData[i].shop_id = data.shopId
          this.tableData[i].shop_name = data.shopName
          this.tableData[i].from_platform = data.fromPlatform
          this.tableData[i].pic = data.images[0]
          this.tableData[i].goodsInventory = res.data.goodsInfo.goodsInventory
          this.tableData[i].show = true
          this.tableData[i].goods_title = data.titleC;
          this.$forceUpdate();
          console.log(this.tableData[i]);
        });
      })

    },
    // 新增
    add() {
      this.tableData.push({
        link: "",
        goods_id: "",
        mi_id: "",
        goods_title: "",
        price: '0',
        detail: "",
        detail_y: "",
        sku_id: "",
        spec_id: "",
        shop_id: "",
        shop_name: "",
        from_platform: "",
        confirm_num: "",
        confirm_freight: "",
        confirm_price: "",
        confirm_dicker_price: "",
        confirm_dicker_freight: "",
        volume: "",
        weight: "",
        g_remark: "",
        length: "",
        width: "",
        height: "",
        pic: "",
        goodsInventory: {}
      });
      this.$forceUpdate();
    },
    // 删除
    delItem(i) {
      this.tableData.splice(i, 1);
      this.$forceUpdate();
    },
    // 修改属性
    editAttribute(item, index) {

      this.goodsInventory = item.goodsInventory
      if (item.show || this.status == 22 || this.status == 21) {
        this.itemDetai = item;
        this.attributeDialogVisible = true;
        this.i = index

      }
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic, goodsInventory) {
      this.goodsInventory = goodsInventory
      this.tableData[this.i].detail_y = data;
      this.tableData[this.i].detail = data;
      if (pic) {
        this.tableData[this.i].pic = pic;
      }
      this.searchPricr(data);
      this.attributeDialogVisible = false;
    },
    // 查找价格
    searchPricr(data) {
      let str = "";
      data.forEach((item) => {
        str += item.value + "㊖㊎";
      });

      str = str.substr(0, str.length - 2);
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {
          this.tableData[this.i].sku_id =
            this.goodsInventory[i].valueC[0].skuId;
          this.tableData[this.i].spec_id =
            this.goodsInventory[i].valueC[0].specId;
          this.tableData[this.i].price = this.goodsInventory[i].valueC[0].price;
          break;
        } else {
          this.tableData[this.i].sku_id = "";
          this.tableData[this.i].spec_id = "";
          this.tableData[this.i].price = "0";

        }
      }
      this.$forceUpdate();
    },
    // 采购保存
    save() {
      //   let flag = this.tableData.every((item) => item.show);
      //   if (!flag) return this.$message.error("请添加商品链接");
      let list = this.tableData;
      for (let i = 0; i < list.length; i++) {
        if (list[i].detail == false) {
          this.$alert("未选择商品属性", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].confirm_num) {
          this.$alert("调查在库数未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].confirm_price || list[i].confirm_price == 0) {
          this.$alert("调查单价未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].confirm_freight) {
          this.$alert("调查运费不能为0为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].confirm_dicker_freight) {
          this.$alert("确认国内运费未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (
          !list[i].confirm_dicker_price ||
          list[i].confirm_dicker_price == 0
        ) {
          this.$alert("实际采购价未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (
          !list[i].length ||
          !list[i].width ||
          !list[i].height ||
          list[i].length == 0 ||
          list[i].width == 0 ||
          list[i].height == 0
        ) {
          this.$alert("单个商品尺寸未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].weight) {
          this.$alert("单个重量未填写", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        list[i].volume =
          list[i].length + "x" + list[i].width + "x" + list[i].height;
      }
      let datas = {
        order_detail_id: this.detail.id,
        list: list,
      };
      this.$api.orderApi.storeReplaceGoods(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.setReplaceGoodsDialogVisible = false;
        this.$parent.detail.order_detail[this.$parent.i].order_detail_replace =
          this.tableData;
        console.log(res);
      });
      console.log(datas);
    },
    // 业务保存
    updateReplaceGoods() {
      let list = JSON.parse(JSON.stringify(this.detail.order_detail_replace));
      let datas = {
        list: [],
      };
      for (let i = 0; i < list.length; i++) {
        if (!list[i].offer_num || list[i].offer_num == 0) {
          this.$alert("报价在库数不能为0或者为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        if (!list[i].offer_price || list[i].offer_price == 0) {
          this.$alert("报价单价不能为0或者为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        datas.list.push({
          confirm_price: list[i].offer_price,
          confirm_freight: list[i].offer_freight,
          confirm_num: list[i].offer_num,
          y_reply: list[i].y_reply,
          id: list[i].id,
        });
      }
      console.log(datas);
      this.$api.orderApi.updateReplaceGoods(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.setReplaceGoodsDialogVisible = false;
        this.$parent.detail.order_detail[this.$parent.i].order_detail_replace =
          this.tableData;
      });
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.tableData[this.i].pic = res.data;
      this.loading = false;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
  },
};
</script>
<style lang='scss' scoped>
.addGoods {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .type {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .radio {
      margin-right: 80px;
    }

    span {
      margin-right: 20px;
    }

    .input {
      width: 100px;
    }
  }

  .add {
    margin-bottom: 15px;
    text-align: right;
  }

  .table {
    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
      }
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .template {
        text-align: center;

        p {
          margin-bottom: 5px;
        }
      }

      .attribute {
        width: 100%;
        padding: 10px;
        background-color: #fff;
        height: 80px;
        overflow: hidden;
      }
    }

    .flex2 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }
  }
}

.row {
  p {
    margin-bottom: 5px;
  }
}

/deep/.el-input__inner {
  text-align: center;
}

/deep/.el-textarea__inner {
  padding: 5px;
  min-height: 63px !important;
  height: 100px !important;
}
</style>
